import { useId, type ReactNode } from "react";

import { Checkbox } from "@/components/ui/checkbox";

/** One tick on a signup form. The label is its own text, so ticking stays an act of its own. */
export const ConsentCheck = ({
  checked,
  onChange,
  children,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
}) => {
  const id = useId();

  return (
    <div className="flex items-start gap-2.5">
      <Checkbox id={id} checked={checked} onCheckedChange={(next) => onChange(next === true)} className="mt-0.5" />
      <label htmlFor={id} className="text-[13px] leading-snug text-muted-foreground">
        {children}
      </label>
    </div>
  );
};
